import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";

@Component({
  selector: "app-link-expiration-dialog",
  standalone: true,
  imports: [DialogModule, ButtonModule, TranslateModule],
  templateUrl: "./link-expiration-dialog.component.html",
  styleUrl: "./link-expiration-dialog.component.scss",
})
export class LinkExpirationDialogComponent {
  @Input() visibleDialog = false;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  closeDialog(): void {
    this.visibleDialog = false;
    this.close.emit();
  }
}
